import { IconSVG } from '../types';

export const VolumeUp = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 40 41"
    style={style}
  >
    <path
      fill="currentColor"
      d="M31.667 20.19c0-2.306-.611-4.41-1.834-6.313a11.371 11.371 0 00-4.916-4.27A1.856 1.856 0 0124 8.71a1.58 1.58 0 01-.083-1.23c.166-.444.465-.763.895-.958a1.55 1.55 0 011.313 0c2.694 1.195 4.847 3.021 6.458 5.48C34.194 14.46 35 17.19 35 20.19c0 3-.806 5.73-2.417 8.187-1.61 2.459-3.764 4.285-6.458 5.48a1.549 1.549 0 01-1.313 0 1.646 1.646 0 01-.895-.959A1.58 1.58 0 0124 31.67c.194-.403.5-.701.917-.896a11.37 11.37 0 004.916-4.27c1.223-1.903 1.834-4.008 1.834-6.313zm-20 5.042h-5c-.473 0-.868-.16-1.188-.48-.32-.319-.479-.715-.479-1.187v-6.667c0-.472.16-.868.48-1.187.319-.32.714-.48 1.187-.48h5l5.5-5.5c.527-.527 1.132-.645 1.812-.354.68.292 1.021.813 1.021 1.563v18.583c0 .75-.34 1.271-1.02 1.563-.681.291-1.286.173-1.813-.354l-5.5-5.5zm15.833-5a7.23 7.23 0 01-.792 3.312c-.527 1.042-1.222 1.896-2.083 2.563a.821.821 0 01-.854.02.767.767 0 01-.438-.729V14.982c0-.334.146-.577.438-.73a.821.821 0 01.854.021c.861.695 1.556 1.57 2.083 2.625a7.357 7.357 0 01.792 3.334zm-10.833-5.25l-3.584 3.583h-4.75v3.333h4.75l3.584 3.584v-10.5z"
    />
  </svg>
);
